import SankeyEdge from './sankey-edge';
import SankeyPart from './sankey-part';
import {SerializedSankeyNode} from './serialized';

export class SankeyNode extends SankeyPart {
  public edges: SankeyEdge[];
  public incomingEdges: SankeyEdge[];
  public index: number;

  constructor(serializedSankeyNode: SerializedSankeyNode) {
    super(serializedSankeyNode);
    this.edges = (serializedSankeyNode.edges || []).map((edge) => new SankeyEdge(edge));
    this.incomingEdges = [];
  }

  public addIncomingEdge(edge): void {
    this.incomingEdges.push(edge);
  }

  // edges are sorted by how high they appear in the flow, this property
  // is maintained by sorting each of the nodes in each step
  public sortEdges(): void {
    this.edges = this.edges.sort((a, b) => a.toNode.index - b.toNode.index);
  }
}
